import React from 'react';

import Box from '@amzn/meridian/box';
import { type BoxProps } from '@amzn/meridian/box/box';
import Button from '@amzn/meridian/button';
import Card from '@amzn/meridian/card';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { useAppSelector } from 'src/store/store';
import { JmrFlowTypes } from 'src/utils/jmrUtils';

// **** Types **** //

interface RestrictionItemBoxProps extends BoxProps {
  restrictionNumber: number;
  label: string;
  description?: string;
  onRemoveRestriction: () => void;
}

// **** Components **** //

/**
 * Update the "selected task name list" when the selected name changes.
 */
const RestrictionItemBox = ({
  label,
  restrictionNumber,
  description,
  onRemoveRestriction,
  children,
  ...boxProps
}: RestrictionItemBoxProps) => {
  // So tests aren't broken
  const { jmrFlowType } = useAppSelector((state) => state.newJmrPage);
  const isDisabled = jmrFlowType === JmrFlowTypes.UpdateDates;

  return (
    <Card type="outline" disabled={true} {...boxProps}>
      {/* Header */}
      <Column spacing="none" spacingInset="none none 200 none">
        <Row alignmentHorizontal="justify">
          <Text type="h200" color="primary">
            {label}
          </Text>
          {!isDisabled && (
            <Button
              type="link"
              onClick={onRemoveRestriction}
              data-cy={`new-jmr__remove-restriction__btn__${restrictionNumber}`}
              data-testid={`new-jmr__remove-restriction__btn__${restrictionNumber}`}
            >
              Remove
            </Button>
          )}
        </Row>
        {description?.length ? (
          <Row alignmentHorizontal="justify">
            <Text type="b200" color="secondary">
              {description}
            </Text>
          </Row>
        ) : null}
      </Column>

      <Box spacingInset="200" />

      {/* Body */}
      {children}
    </Card>
  );
};

// **** Export **** //

export default RestrictionItemBox;
